import React, { useContext, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { AccountsContext } from '../../components/context/account-context';
import { createNote } from '../../services/notes-service';
import Button from '../../components/shared/custom-btn';
import CustomTextarea from '../../components/shared/custom-textarea';
import ModalHeading from '../../components/shared/modal-heading';
import { ApiResponseMessage } from '../../components/shared/api-response';

const AddModal = ({
    handleCloseAddModal,
    onAdd,
    openEditModal,
    fetchNotes,
    linkedType,
    linkedId
}) => {
    const { accountId } = useContext(AccountsContext);
    const [formData, setFormData] = useState({
        linkedType: linkedType || '',
        linkedId: linkedId || '',
        note: '',
    });
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState({ message: '', type: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (apiResponse.message) setApiResponse({ message: '', type: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading || apiResponse.type === 'success') return;
        if (!formData.note.trim()) {
            setApiResponse({ message: 'Note cannot be empty', type: 'error' });
            return;
        }

        setLoading(true);

        try {
            const response = await createNote({ ...formData }, accountId);

            if (response.success) {
                setApiResponse({ message: 'Note created successfully!', type: 'success' });
                onAdd?.(response.data.data);
                fetchNotes?.('Notes');
                openEditModal?.(response.data.data);
                setTimeout(handleCloseAddModal, 1000); // Give user time to see success message
            } else {
                throw new Error(response.data.message || 'Failed to create note');
            }
        } catch (error) {
            setApiResponse({
                message: error.message || 'An unexpected error occurred',
                type: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-2 pt-3 relative">
            <ModalHeading className="text-left mb-3 border-b border-gray-300 px-4 pb-2">
                Add Note
            </ModalHeading>

            <button
                type="button"
                className="absolute -top-2 right-2 bg-white border p-2 rounded-full hover:scale-105 transition"
                onClick={handleCloseAddModal}
                disabled={loading}
            >
                <RxCross2 className="text-xl" />
            </button>

            <ApiResponseMessage response={apiResponse} />

            <div className="px-4">
                <CustomTextarea
                    label="Note"
                    name="note"
                    value={formData.note}
                    onChange={handleChange}
                    rows={4}
                    required
                    maxLength={500}
                    disabled={loading}
                    className="min-h-[100px]"
                />
            </div>

            <div className="flex justify-end px-4 pt-2">
                <Button
                    label={'Save'}
                    loading={loading}
                    loadingLabel='Saving...'
                    type='submit'
                    disabled={loading || apiResponse.type === 'success'}
                    className={`bg-btnBg rounded-lg !py-1 text-white`}
                />
            </div>
        </form>
    );
};

export default AddModal;